import React, { useEffect, useState } from "react";
import Navbar from "../../../common/layout/Navbar";
import { LicenseTypes, PageFrom } from "../../../../utils/Enum.types";
import { Title } from "../../../../stories/Title/Title";
import Input from "../../../../stories/Input/Input";
import { TextField } from "@mui/material";
import { Button } from "../../../../stories/Button/Button";
import Close from "../../../../images/Close.svg";
import { useNavigate } from "react-router-dom";

import WorkProgressItem from "./WorkProgressItem";
import useUrlParams from "../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { useLazyQuery } from "@apollo/client";
import {
  GetProjectsTableHeaderCountResult,
  GetProjectsTableHeaderCountVar,
} from "../masters/projects/queries/types";
import { GetProjectsTableHeaderCount } from "../masters/projects/queries/queries";
import { pollingMinutes } from "../../../../utils/constants";

interface Props {
  pageFrom: PageFrom;
}
const WorkProgress = ({ pageFrom }: Props) => {
  const navigate = useNavigate();

  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const [GetProjects, { data }] = useLazyQuery<
    GetProjectsTableHeaderCountResult,
    GetProjectsTableHeaderCountVar
  >(GetProjectsTableHeaderCount, {
    pollInterval: pageFrom === PageFrom.DASHBOARD ? pollingMinutes : undefined,
  });

  useEffect(() => {
    if (customer_id)
      GetProjects({
        variables: {
          customerID: customer_id,
          empID: user_details.id,
          toAddHeaders: false,
        },
      });
  }, [customer_id, user_details.id, GetProjects]);

  return (
    <>
      {pageFrom !== PageFrom.DASHBOARD && (
        <>
          <Navbar NavType={LicenseTypes.DASHBOARD} />
          <Title>Work Progress</Title>
        </>
      )}

      <div className="work-progress">
        {pageFrom === PageFrom.DASHBOARD && <Title>Work Progress</Title>}
        <div className="work-progress__row row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col"></div>
          {/* <div className="col-2 flex-end">
            <TextField
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              label="Date"
              className="work-progress__row--text-field"
            />
          </div> */}
        </div>
        <div className="work-progress__block">
          <div className="work-progress__block--grids">
            {data
              ? data.GetProjectsTableHeaderCount.map((res, index) => {
                  return (
                    <WorkProgressItem
                      res={res as any}
                      index={index}
                      key={index}
                    />
                  );
                })
              : null}
          </div>
        </div>

        {pageFrom !== PageFrom.DASHBOARD && (
          <Button mode="back" onClick={() => navigate(-1)} />
        )}
      </div>
    </>
  );
};

export default WorkProgress;
